import { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import { configs } from "configs";

const useWhatsappSocket = (phoneNumber) => {
  const [qrCode, setQrCode] = useState(null);      
  const [isLinked, setIsLinked] = useState(false);
  const socketRef = useRef(null);
  useEffect(() => {
    if (!phoneNumber) return;
    const number = phoneNumber.startsWith('+') ? phoneNumber.slice(1) : phoneNumber;
    socketRef.current = io(process.env.REACT_APP_LENSE_URL, {
      path: "/api/socket.io",
      transports: ['websocket'],
    });
    const socket = socketRef.current;
     const handleConnect = () => {
        socket.emit("start-session", {
          cellNumber: number,
          tenant: "propforce",
          subTenant: configs?.lensSubTenant || "propforce_zameen"
        });
    };
    socket.on("connect", handleConnect);
    socket.on("qr", ({ qr }) => {
      setQrCode(qr);
    });
     socket.on("connected", ({ message }) => {
      setIsLinked(true)
    });
    return () => {
      socket.disconnect();
    };
  }, [phoneNumber]);

  return { qrCode, isLinked };
};
export default useWhatsappSocket